<template>
  <div>
    <cs-form-dialog
      v-model="popupDialog"
      :heading="dialogTitle"
      :primary-action="primaryButtonAction"
      :secondary-action1="secondaryButtonAction"
      @primary-click="openUpdateDialog"
      @secondary1-click="exportUpdateNotes"
    >
      <template v-slot:cs-form-dialog-content>
        <div id="content-update-notes">
          <v-card-title>
            <v-list-subheader>Summary</v-list-subheader>
          </v-card-title>
          <v-card-text>
            <div class="pl-4 pr-4" v-html="summary"></div>
          </v-card-text>
        </div>
      </template>
    </cs-form-dialog>
    <update-c-e-module-dialog
      :file-diff="fileDiff"
      :publishId="publishId"
      :moduleId="moduleId"
      :show-dialog="showNewUpdateDialog"
      @closed="showNewUpdateDialog = false"
      @updateParent="updateParent"
    ></update-c-e-module-dialog>
  </div>
</template>

<script>
import { CSBase, CSFormDialog } from '@complispace/cs-design-system';
import { exportPageHTML } from '@/constants';
import { mapState } from 'vuex';
import UpdateCEModuleDialog from './UpdateCEModuleDialog';

export default {
  name: 'ShowUpdateCEModuleDialog',
  extends: CSBase,

  components: {
    UpdateCEModuleDialog,
    CSFormDialog
  },

  props: {
    showDialog: { type: Boolean, required: true, default: false },
    summary: { type: String, required: true },
    fileDiff: { type: Object, required: true },
    publishId: { type: Number, required: true },
    moduleId: { type: Number, required: true },
    allowUpdate: { type: Boolean, required: false, default: true },
    dialogTitle: { type: String, required: false, default: 'Update Module' },
    moduleDisplayName: { type: String, required: false }
  },

  data() {
    return {
      popupDialog: false,
      showNewUpdateDialog: false
    };
  },

  watch: {
    showDialog(value) {
      if (value) {
        this.popupDialog = true;
      }
    },

    popupDialog(value) {
      if (!value) {
        this.$emit('closed');
      }
    }
  },

  computed: {
    ...mapState({
      client: (state) => state.client
    }),

    primaryButtonAction() {
      return this.allowUpdate ? { label: 'Update', eventName: 'dlg-update' } : null;
    },

    secondaryButtonAction() {
      return this.allowUpdate ? { label: 'Export', eventName: 'dlg-export' } : null;
    }
  },

  methods: {
    openUpdateDialog() {
      this.showNewUpdateDialog = true;
      this.popupDialog = false;
    },

    async exportUpdateNotes() {
      const updateNotes = document.getElementById('content-update-notes');
      const filename = this.moduleDisplayName
        ? `${this.moduleDisplayName} Update Notes`
        : 'Print View';
      const winPrint = window.open('', filename, 'toolbar=0,titlebar=1,scrollbars=1,status=0');

      const exportedHTML = exportPageHTML(
        undefined,
        undefined,
        filename,
        this.client.logoUri,
        updateNotes.innerHTML,
        { includeHeader: false, includeFooter: false }
      );

      winPrint.document.write(exportedHTML);
      winPrint.document.close();
    },

    updateParent() {
      this.$emit('updateParent');
    }
  }
};
</script>
<style scoped>
#content-update-notes :deep(.primary--text) {
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
